module.exports = __webpack_public_path__ + "img/newslist-empty.64764e2b.png";